'use client'

import { cn } from '@/lib/utils'
import { useStoreI18n } from '@/store'
import { Typo3ReportsIcerink } from '@/types'
import { StatusChip } from '@/ui/components'
import { memo } from 'react'

const AccordionHead = ({ ...data }: Typo3ReportsIcerink) => {
  const D = useStoreI18n.use.dictionary()

  return (
    <div className={''}>
      <div className={cn('')}>
        <h3 className={cn('', 'h3')}>{data.title}</h3>
      </div>

      <div className={''}>
        <div className="text-small text-neutral-400">
          {D['fe.winterHike.status']}
        </div>
        <div className={''}>
          <StatusChip status={data.status === 'OPEN' ? 'success' : 'error'} />
        </div>
      </div>
    </div>
  )
}

export default memo(AccordionHead)
